module.exports = __webpack_public_path__ + "static/media/corporate-services-img3.5da213e2.jpg";